var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.847.043a.61.61 0 0 0-.219.131c-.182.182-.175.041-.175 3.324v2.955H3.537c-1.865 0-2.968.01-3.059.027-.198.038-.337.136-.407.289-.056.12-.058.163-.066 1.173-.008 1.186.001 1.262.169 1.43.182.182.04.175 3.324.175h2.955v2.955c0 3.283-.007 3.142.175 3.324C6.792 15.99 6.87 16 8 16c1.13 0 1.208-.01 1.372-.174.182-.182.175-.041.175-3.324V9.547h2.955c3.284 0 3.142.007 3.324-.175.168-.168.177-.244.169-1.43-.008-1.042-.009-1.049-.072-1.177-.076-.156-.206-.248-.401-.285-.091-.017-1.194-.027-3.059-.027H9.547V3.498c0-3.283.007-3.142-.175-3.324C9.207.009 9.131 0 7.988.002c-.81.001-1.04.01-1.141.041","fill":"","fillRule":"evenodd"}));
}

Plus.defaultProps = {"viewBox":"0 0 16 16","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
